import { LOST_LEADS_REPORT } from '@mm/api-routes';
import { ObjectUtils } from '@mm/utils';
import { Kind, UtmCampaign } from '../interfaces/lostLeadsReport';
import Controller from './Controller';

export default class LostLeadsReportController extends Controller {
  static createReport(
    website: string,
    kind: Kind,
    utmCampaign: UtmCampaign,
  ): Promise<any> {
    const params = ObjectUtils.deepSnakeKeys({
      website,
      kind,
      ...utmCampaign,
    });
    return super.post(LOST_LEADS_REPORT, params);
  }
}
